import React from 'react'
import { Button, Form, Input, Modal, message } from 'antd'
import TableAPI from '../../../components/TableAPI'
import { columns } from './columns'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'
import { View } from '../../../../styles/reactnative'

const AdminPCSetting = () => {
	const [modalVisible, setModalVisible] = React.useState(false)
	const [pc, setPc] = React.useState('')
	const [memo, setMemo] = React.useState('')
	const { data: token } = useToken()

	return (
		<>
			<TableAPI
				title={'관리 PC등록'}
				columns={columns}
				usermodal={false}
				height={'default'}
				apikey={`/admin/pc?t=`}
				pagination={false}
				action={mutate => {
					return (
						<Button
							type="primary"
							onClick={() => {
								setModalVisible(true)
							}}>
							PC등록
						</Button>
					)
				}}
				actionmodal={mutate => {
					return (
						<Modal
							title="관리 PC등록"
							visible={modalVisible}
							okText="등록"
							cancelText="취소"
							onOk={() => {
								API.send('POST', '/admin/pc', token + '', {
									pc: pc,
									memo: memo,
								}).then(res => {
									message.success('등록되었습니다.')
									mutate(1)
								})
								setModalVisible(false)
							}}
							onCancel={() => {
								setModalVisible(false)
							}}>
							<Input
								value={pc}
								onChange={e => setPc(e.target.value)}
								placeholder="PC코드"
							/>
							<Input
								value={memo}
								onChange={e => setMemo(e.target.value)}
								placeholder="메모"
							/>
						</Modal>
					)
				}}
			/>
		</>
	)
}

export default React.memo(AdminPCSetting)
